var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);

// ../utils.ts
var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.navigator !== "undefined";
var DISPLAY_BLOCK = ":host(:not([hidden])) { display: block }";
var UHTMLElement = typeof HTMLElement === "undefined" ? class {
} : HTMLElement;
var events = (action, element, rest) => rest[0].split(",").forEach((type) => {
  rest[0] = type;
  Element.prototype[`${action}EventListener`].apply(element, rest);
});
var on = (element, ...rest) => events("add", element, rest);
var off = (element, ...rest) => events("remove", element, rest);
var asButton = (event) => {
  const isClick = "key" in event && (event.key === " " || event.key === "Enter");
  if (isClick) event.preventDefault();
  if (isClick && event.target instanceof HTMLElement) event.target.click();
  return isClick;
};
var getRoot = (node) => node.getRootNode();
var createElement = (tagName, props) => Object.assign(document.createElement(tagName), props);
var customElements = {
  define: (name, instance) => !IS_BROWSER || window.customElements.get(name) || window.customElements.define(name, instance)
};

// u-details.ts
var OPEN = "open";
var USUMMARY_TAG = "U-SUMMARY";
var _content;
var UHTMLDetailsElement = class extends UHTMLElement {
  constructor() {
    super();
    __privateAdd(this, _content);
    this.attachShadow({ mode: "closed" }).append(
      createElement("slot", { name: "summary" }),
      // Summary slot
      __privateSet(this, _content, createElement("slot")),
      // Content slot
      createElement("style", {
        textContent: `
        ${DISPLAY_BLOCK}
        ::slotted(u-summary) { cursor: pointer; display: list-item; counter-increment: list-item 0; list-style: disclosure-closed inside }
        ::slotted(u-summary[aria-expanded="true"]) { list-style-type: disclosure-open }
      `
      })
    );
  }
  connectedCallback() {
    on(__privateGet(this, _content), "beforematch", this);
    this.attributeChangedCallback();
  }
  disconnectedCallback() {
    off(__privateGet(this, _content), "beforematch", this);
  }
  attributeChangedCallback(prop, prev, next) {
    const hide = "onbeforematch" in this ? "until-found" : true;
    const open = this[OPEN];
    Array.from(this.children, (el) => {
      if (el.nodeName === USUMMARY_TAG) el.ariaExpanded = `${open}`;
    });
    __privateGet(this, _content).ariaHidden = `${!open}`;
    __privateGet(this, _content).hidden = open ? false : hide;
    if (hide === "until-found")
      __privateGet(this, _content).style.display = open ? "" : "block";
    if (open && this.name)
      getRoot(this).querySelectorAll(
        `${this.nodeName}[name="${this.name}"]`
      ).forEach((uDetails) => uDetails === this || (uDetails[OPEN] = false));
    if (prop === OPEN && prev === null !== (next === null))
      this.dispatchEvent(new Event("toggle"));
  }
  handleEvent({ type }) {
    if (type === "beforematch") this[OPEN] = true;
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(open) {
    this.toggleAttribute("open", open);
  }
  get name() {
    return this.getAttribute("name") || "";
  }
  set name(value) {
    this.setAttribute("name", value);
  }
};
_content = new WeakMap();
UHTMLDetailsElement.observedAttributes = [OPEN];
var UHTMLSummaryElement = class extends UHTMLElement {
  connectedCallback() {
    this.role = "button";
    this.slot = "summary";
    this.tabIndex = 0;
    on(this, "click,keydown", this);
  }
  disconnectedCallback() {
    off(this, "click,keydown", this);
  }
  handleEvent(event) {
    const details = this.parentElement;
    if (event.type === "keydown") asButton(event);
    if (event.type === "click" && details instanceof UHTMLDetailsElement)
      details[OPEN] = !details[OPEN];
  }
};
customElements.define("u-details", UHTMLDetailsElement);
customElements.define("u-summary", UHTMLSummaryElement);

export { UHTMLDetailsElement, UHTMLSummaryElement };
